import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableFooter, TablePagination } from '@mui/material';
import Row from './Row';
import VendorApplicationDetailsModal from './VendorApplicationDetailsModal';

export default function VendorEventsTable({ eventList }) {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    setPage(0);
  }, [eventList]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const openDetails = (row) => {
    setOpenDetailsModal(true);
    setSelectedRow(row);
  };

  const handleCloseModal = () => {
    setOpenDetailsModal(false);
  };

  return (
    <>
      <TableContainer component={Paper} style={{ borderRadius: 20 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Business Name</TableCell>
              <TableCell align="left">Details</TableCell>
              <TableCell align="left">Total Price</TableCell>
              <TableCell align="left">Vendor Email</TableCell>
              <TableCell align="left">Phone Number</TableCell>
              <TableCell align="left">Payment Status</TableCell>
              <TableCell align="left">Application Status</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? eventList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : eventList
            ).map((row) => (
              <Row key={row.id} row={row} openDetails={openDetails} />
            ))}
          </TableBody>
        </Table>
        <TableFooter sx={{ display: 'flex', justifyContent: 'end' }}>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              component="div"
              count={eventList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </TableContainer>
      <VendorApplicationDetailsModal
        isOpen={openDetailsModal}
        handleClose={handleCloseModal}
        details={selectedRow}
      />
    </>
  );
}

VendorEventsTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  eventList: PropTypes.array.isRequired,
};
